/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/**
 * Podobne losowania - model i render po stronie przegladarki.
 *
 * Model jest wiernym odpowiednikiem an_podobne_raport() z bin/lib-podobne.php:
 * liczy wylacznie na przekazanym wejsciu, nie siega do sieci ani DOM
 * i nie modyfikuje obiektu wejsciowego.
 */
(function (global) {
    'use strict';

    function enText(pl, en) { return typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? en : pl; }

    var LIMIT_WIERSZY = 10;

    /** Liczba calkowita z number bez czesci ulamkowej albo napisu cyfrowego. */
    function calkowita(wartosc) {
        if (typeof wartosc === 'number') {
            return isFinite(wartosc) && Math.floor(wartosc) === wartosc ? wartosc : null;
        }
        if (typeof wartosc === 'string' && /^\s*[+-]?\d+\s*$/.test(wartosc)) {
            return parseInt(wartosc.trim(), 10);
        }
        return null;
    }

    /** Zbior dokladnie `ile` unikalnych liczb z zakresu 1..max; null = niepoprawny. */
    function zbior(dane, ile, max) {
        if ((dane === null || dane === undefined) && ile === 0) {
            return {};
        }
        if (!Array.isArray(dane) || dane.length !== ile) {
            return null;
        }

        var wynik = {};
        var licznik = 0;
        for (var i = 0; i < dane.length; i++) {
            var n = calkowita(dane[i]);
            if (n === null || n < 1 || n > max) {
                return null;
            }
            if (!Object.prototype.hasOwnProperty.call(wynik, n)) {
                wynik[n] = true;
                licznik++;
            }
        }

        return licznik === ile ? wynik : null;
    }

    /** Unikalne liczby losowania nalezace do zestawu gracza. */
    function trafienia(liczby, zestaw) {
        if (!Array.isArray(liczby)) {
            return 0;
        }
        var trafione = {};
        var ile = 0;
        for (var i = 0; i < liczby.length; i++) {
            var n = calkowita(liczby[i]);
            if (n !== null && Object.prototype.hasOwnProperty.call(zestaw, n)) {
                if (!Object.prototype.hasOwnProperty.call(trafione, n)) {
                    trafione[n] = true;
                    ile++;
                }
            }
        }
        return ile;
    }

    /** Znacznik czasu do sortowania; data nieczytelna nie przerywa raportu. */
    function znacznik(data) {
        if (!data) {
            return 0;
        }
        var ts = Date.parse(data);
        return isNaN(ts) ? 0 : ts;
    }

    function model(wejscie) {
        var we = (wejscie && typeof wejscie === 'object') ? wejscie : {};

        var pula = calkowita(we.pula);
        var typuje = calkowita(we.typuje);
        var specPula = calkowita(we.special_pula === undefined || we.special_pula === null ? 0 : we.special_pula);
        var specTypuje = calkowita(we.special_typuje === undefined || we.special_typuje === null ? 0 : we.special_typuje);

        if (pula === null || typuje === null || specPula === null || specTypuje === null
            || pula < 1 || typuje < 1 || typuje > pula
            || specPula < 0 || specTypuje < 0 || specTypuje > specPula) {
            return { powod: 'niepoprawny_zestaw' };
        }

        var zestaw = zbior(we.zestaw === undefined ? null : we.zestaw, typuje, pula);
        var zestawSpec = zbior(
            we.zestaw_special === undefined || we.zestaw_special === null ? [] : we.zestaw_special,
            specTypuje,
            specPula
        );

        if (zestaw === null || zestawSpec === null) {
            return { powod: 'niepoprawny_zestaw' };
        }

        var losowania = Array.isArray(we.losowania) ? we.losowania : [];
        var wiersze = [];
        var rozklad = [];
        for (var r = 0; r <= typuje; r++) rozklad[r] = 0;

        for (var i = 0; i < losowania.length; i++) {
            var l = losowania[i];
            if (!l || typeof l !== 'object') {
                continue;
            }
            var data = typeof l.drawn_at === 'string' ? l.drawn_at : '';
            var numer = calkowita((l.draw_system_id ?? l.legacy_id));
            var mainHits = trafienia(l.numbers, zestaw);
            rozklad[mainHits] = (rozklad[mainHits] || 0) + 1;
            var rozmiarLosowania = Array.isArray(l.numbers) ? l.numbers.length : typuje;
            var sumaZbiorow = typuje + rozmiarLosowania - mainHits;
            wiersze.push({
                data: data,
                numer: numer === null ? 0 : numer,
                main_hits: mainHits,
                special_hits: trafienia(l.special, zestawSpec),
                jaccard: sumaZbiorow ? mainHits / sumaZbiorow : 0,
                hamming: typuje + rozmiarLosowania - 2 * mainHits,
                _ts: znacznik(data)
            });
        }

        wiersze.sort(function (a, b) {
            if (a.main_hits !== b.main_hits) {
                return b.main_hits - a.main_hits;
            }
            if (a.special_hits !== b.special_hits) {
                return b.special_hits - a.special_hits;
            }
            if (a._ts !== b._ts) {
                return a._ts - b._ts;
            }
            return a.numer - b.numer;
        });

        var wyniki = wiersze.map(function (w) {
            return {
                data: w.data,
                numer: w.numer,
                main_hits: w.main_hits,
                special_hits: w.special_hits,
                jaccard: w.jaccard,
                hamming: w.hamming
            };
        });

        return { powod: null, N: wyniki.length, wyniki: wyniki, rozklad: rozklad };
    }

    /* ---------- render ---------- */

    function zdaniaWnioskow(raport) {
        if (!raport || raport.powod !== null) {
            return [jst("pages_podobne_model_js.7757f620e36c")];
        }
        if (raport.N === 0) {
            return [jst("pages_podobne_model_js.4aa96989ce32")];
        }

        var naj = raport.wyniki[0];
        var pelne = 0;
        var zero = 0;
        for (var i = 0; i < raport.wyniki.length; i++) {
            if (raport.wyniki[i].main_hits === naj.main_hits) {
                pelne++;
            }
            if (raport.wyniki[i].main_hits === 0) {
                zero++;
            }
        }

        var zdania = [];
        zdania.push(jst("pages_podobne_model_js.ac1afba73c90") + naj.main_hits
            + jst("pages_podobne_model_js.97eb3502552b") + (naj.data || jst("pages_podobne_model_js.755dbe1917f7")) + ').');
        zdania.push(jst("pages_podobne_model_js.cd3da02fa55a") + pelne + jst("pages_podobne_model_js.e614b0f9e248") + raport.N
            + jst("pages_podobne_model_js.d66fe83901fe"));
        zdania.push(jst("pages_podobne_model_js.2f64ca99e34b") + zero + jst("pages_podobne_model_js.f09e81cc94d5"));
        return zdania;
    }

    function wyczysc(el) {
        while (el && el.firstChild) {
            el.removeChild(el.firstChild);
        }
    }

    function komorka(wiersz, rola, wartosc) {
        var td = document.createElement('td');
        td.setAttribute('data-pp-cell', rola);
        td.textContent = String(wartosc);
        wiersz.appendChild(td);
    }

    function render(root, wejscie) {
        if (!root || typeof document === 'undefined') {
            return null;
        }

        root.setAttribute('data-pp-root', 'podobne');

        var raport = (wejscie === null || wejscie === undefined) ? null : model(wejscie);

        /* wnioski stoja PRZED wynikami */
        var wnioski = root.querySelector('[data-analiza-wnioski]');
        if (!wnioski) {
            wnioski = document.createElement('div');
            wnioski.setAttribute('data-analiza-wnioski', '');
            root.insertBefore(wnioski, root.firstChild);
        }
        var lista = wnioski.querySelector('.wniosek__lista');
        if (!lista) {
            lista = document.createElement('ul');
            lista.className = 'wniosek__lista';
            wnioski.appendChild(lista);
        }
        wyczysc(lista);
        var zdania = raport === null
            ? [jst("pages_podobne_model_js.7c2ee1878f4b")]
            : zdaniaWnioskow(raport);
        for (var z = 0; z < zdania.length; z++) {
            var li = document.createElement('li');
            li.className = 'wniosek__punkt';
            li.textContent = zdania[z];
            lista.appendChild(li);
        }

        /* licznik N */
        var licznik = root.querySelector('[data-pp-value="N"]');
        if (!licznik) {
            licznik = document.createElement('span');
            licznik.setAttribute('data-pp-value', 'N');
            root.appendChild(licznik);
        }
        licznik.textContent = (raport && raport.powod === null) ? String(raport.N) : '0';
        var rozklad = root.querySelector('[data-podobne-rozklad]');
        if (rozklad) {
            rozklad.textContent = raport && raport.powod === null ? raport.rozklad.map(function (n, i) {
                return i + ': ' + n;
            }).join(' · ') : '—';
        }

        /* tabela */
        var tbody = root.querySelector('[data-pp-body]');
        if (!tbody) {
            var tabela = document.createElement('table');
            tabela.className = 'tabela';
            var thead = document.createElement('thead');
            var hr = document.createElement('tr');
            [jst("pages_podobne_model_js.77dac883b756"), jst("pages_podobne_model_js.05544560a572"), jst("pages_podobne_model_js.daee98507ed2"), jst("pages_podobne_model_js.fe4c1ca6247b")].forEach(function (t) {
                var th = document.createElement('th');
                th.scope = 'col';
                th.textContent = t;
                hr.appendChild(th);
            });
            thead.appendChild(hr);
            tabela.appendChild(thead);
            tbody = document.createElement('tbody');
            tbody.setAttribute('data-pp-body', '');
            tabela.appendChild(tbody);
            root.appendChild(tabela);
        }
        wyczysc(tbody);

        var pusty = (raport === null || raport.powod !== null || raport.N === 0);
        if (pusty) {
            root.setAttribute('data-pp-empty', '');
        } else {
            root.removeAttribute('data-pp-empty');
            var ile = Math.min(LIMIT_WIERSZY, raport.wyniki.length);
            for (var i = 0; i < ile; i++) {
                var w = raport.wyniki[i];
                var tr = document.createElement('tr');
                tr.setAttribute('data-pp-row', String(i + 1));
                komorka(tr, 'data', w.data);
                komorka(tr, 'numer', w.numer);
                komorka(tr, 'main_hits', w.main_hits);
                komorka(tr, 'special_hits', w.special_hits);
                komorka(tr, 'jaccard', Math.round(w.jaccard * 1000) / 1000);
                komorka(tr, 'hamming', w.hamming);
                tbody.appendChild(tr);
            }
        }

        return raport;
    }

    global.PEWNIAKI_PODOBNE = { model: model, render: render };
})(typeof window !== 'undefined' ? window : globalThis);
